/* eslint-disable react/jsx-props-no-spreading */
// todo: remove eslint-disable
import {
  Autocomplete, Box,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTextField from '../../../../components/CustomTextField';
import STRING_KEYS from '../../../../language/keys';
import { NoAcademics } from './NoAcademics';
import { style } from './style';

type InstitutionAutocompleteProps = {
  listAutocomplete:Academic[],
  onInputValueChange: (event:React.SyntheticEvent, newInputValue:string) => void,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onOptionSelected: (event:React.SyntheticEvent, newInputValue:any) => void,
  onChangeValues: (event:React.SyntheticEvent, newInputValue:string) => void,
  valueName: string,
  label: string,
  disabled?: boolean,
  isLoading: boolean,
  viewMode: ViewMode
  academicInstitutGetFrom: string,
  onOpenCreateNewEducationModal?: ((id:string) => void) | undefined,
  id: string,
}
const InstitutionAutocomplete = ({
  listAutocomplete,
  onInputValueChange,
  onOptionSelected,
  valueName,
  label,
  onChangeValues,
  disabled = false,
  viewMode,
  isLoading,
  academicInstitutGetFrom,
  onOpenCreateNewEducationModal,
  id,
}: InstitutionAutocompleteProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Autocomplete
      fullWidth
      disabled={ disabled }
      loading={ isLoading }
      loadingText={ translate(STRING_KEYS.SEARCHING) }
      noOptionsText={ (
        <NoAcademics
          academicsGetFrom={ academicInstitutGetFrom }
          listAutocomplete={ listAutocomplete }
          valueName={ valueName }
          onOpenCreateNewCompanyModal={ () => {
            if (onOpenCreateNewEducationModal) {
              onOpenCreateNewEducationModal(id);
            }
          } }
        />
      ) }
      inputValue={ valueName }
      options={ listAutocomplete || [] }
      onChange={ onOptionSelected }
      autoHighlight
      getOptionLabel={ (option) => {
        return valueName || option.name;
      } }
      renderOption={ (props, option) => {
        return (
          <Box
            component="li"
            { ...props }
            sx={ { '& > img': { mr: 2, flexShrink: 0 } } }
            key={ option.id }
          >
            <img
              loading="lazy"
              style={ style.image }
              src={ option.logo }
              alt=""
            />
            {option.name}
          </Box>
        );
      } }
      renderInput={ (params) => (
        <CustomTextField
          { ...params }
          label={ label }
          viewMode={ viewMode }
          inputProps={ {
            ...params.inputProps,
          } }
          onChange={ (e: React.ChangeEvent<HTMLInputElement>) => {
            onInputValueChange(e, e.target.value);
            onChangeValues(e, e.target.value);
          } }
        />
      ) }
    />
  );
};

InstitutionAutocomplete.defaultProps = {
  disabled: false,
  onOpenCreateNewEducationModal: undefined,
};

export default InstitutionAutocomplete;
